function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1254 -1280)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1255.002 1285.713)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.562 4.105)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M283.745,377.6a.946.946,0,0,0,1.148-.692,4.252,4.252,0,0,1,8.252,0,.948.948,0,0,0,1.841-.456,6.148,6.148,0,0,0-11.933,0A.948.948,0,0,0,283.745,377.6Zm9.515,1.9c-3.022,0-4.166,2.291-5.086,4.132-.956,1.914-1.632,3.088-3.4,3.088a2.662,2.662,0,1,1,1.327-4.971.924.924,0,0,0,1.119-.137l.025-.025a.942.942,0,0,0-.2-1.482,4.558,4.558,0,1,0-2.273,8.51c3.028,0,4.173-2.293,5.094-4.136.955-1.912,1.629-3.083,3.389-3.083a2.662,2.662,0,1,1-1.327,4.971.952.952,0,0,0-1.144.161.942.942,0,0,0,.2,1.482,4.558,4.558,0,1,0,2.273-8.51Z",
  transform: "translate(-280.22 -371.787)",
  fill: "#1fc5db"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H3.921",
  transform: "translate(0.392 16.295)",
  fill: "none",
  stroke: "#1fc5db",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H3.921",
  transform: "translate(20.261 16.295)",
  fill: "none",
  stroke: "#1fc5db",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.671,0H21.9a2.671,2.671,0,0,1,2.671,2.671V21.9A2.671,2.671,0,0,1,21.9,24.574H2.671A2.671,2.671,0,0,1,0,21.9V2.671A2.671,2.671,0,0,1,2.671,0Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#1fc5db",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H36V36H0Z",
  transform: "translate(1254 1280)",
  fill: "none"
}));

var SvgPassport36Px = function SvgPassport36Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassport36Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passport_36px.129d4729.svg";
export { ForwardRef as ReactComponent };